import type { UseMutationResult } from "@tanstack/react-query";
import type { accountCopyFetchInterface } from "@dealer-center/ddc-pages-media-library-copy-fetch";
import { useMediaLibraryCopyGetStatus } from "@dealer-center/ddc-pages-media-library-copy-fetch";
import { useEffect, useState } from "react";
import { PagesAccountCopyUiResultsDisplay } from "./ResultsDisplay";
import { useGetAccountId } from "@dealer-center/ddc-api-account-fetch";

interface PagesAccountCopyUiResultsProps {
  performCopyMutation: UseMutationResult<
    string,
    Error,
    accountCopyFetchInterface,
    unknown
  >;
  targetAccountId: string;
}

export const PagesAccountCopyUiResults = ({
  performCopyMutation,
  targetAccountId
}: PagesAccountCopyUiResultsProps) => {
  const selectedDealer = useGetAccountId();
  const [refetchInterval, setRefetchInterval] = useState<number | undefined>(
    undefined
  );
  const { data: statusData, isFetching } = useMediaLibraryCopyGetStatus(
    performCopyMutation.data,
    refetchInterval
  );
  useEffect(() => {
    setRefetchInterval(statusData?.status === "InProgress" ? 5000 : undefined);
  }, [statusData?.status]);

  return (
    <PagesAccountCopyUiResultsDisplay
      error={
        performCopyMutation.error
          ? performCopyMutation.error.message ||
            performCopyMutation.error.toString() ||
            "An error occurred"
          : undefined
      }
      isFetching={isFetching}
      isPending={performCopyMutation.isPending}
      selectedDealer={selectedDealer}
      statusData={statusData}
      targetAccountId={targetAccountId}
    />
  );
};
